import { DatasourcedWidgetMetadata } from '@/modules/ta/widget/models/metadata/DataSourcedWidgetMetadata';
import { GeoChartDrawOption } from '@/modules/ta/widget/models/drawoptions/GeoChartDrawOption';
import { GeoCodeType } from '@/modules/core/maps/maps.constants';

export class GeoChartWidgetMetadata extends DatasourcedWidgetMetadata {
  /**
   * @var {string}
   */
  map_id;

  /**
   * @var {string}
   */
  geo_code;

  /**
   * @var {Object}
   */
  map_zoom;

  /**
   * @var {string}
   */
  mapbox_position;

  /**
   * @var {BaseDrawOption}
   */
  draw_options;

  constructor(model = {}) {
    super(model);

    let { map_zoom } = model;
    if (Array.isArray(map_zoom) && map_zoom.length === 0) {
      map_zoom = {};
    }

    this.geo_code = model.geo_code || GeoCodeType.WORLD;
    this.map_id = model.map_id;
    this.map_zoom = map_zoom ?? {};
    this.mapbox_position = model.mapbox_position;
    this.draw_options = new GeoChartDrawOption(model.draw_options);
  }
}
